import { use } from 'react'
import { InternalPageHeaderContext } from './InternalPageHeaderContext'

export const usePageHeaderContext = () => {
  return use(InternalPageHeaderContext)
}
